import LensSvg from '@/shared/assets/images/MagnifyingGlass.svg'
import { FC } from "react"
import { DropdownItem } from "@/shared/ui/dropdown-item"
import { IInvitation } from "@/shared/api/invitations"
import { useUpdateInvitationModal } from "@/features/update-invitation"

interface InspectInvitationProps {
    invitation: IInvitation
}

export const InspectInvitation: FC<InspectInvitationProps> = ({ invitation }) => {
    const { openInspectInvitationModal } = useUpdateInvitationModal()
    return (
        <DropdownItem 
            onClick={() => openInspectInvitationModal(invitation)}
            icon={LensSvg} 
            label={"Просмотреть"}        
        />
    )
}